import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_URL; // Replace with your API base URL

const axiosInstance = axios.create({
  baseURL,
});

export default axiosInstance;